import { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const Cross: FC<IconProps> = ({ width = 16, height = 16, fill = '#9CA3AF', fillBg = 'white', className }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <rect width="16" height="16" rx="8" fill={fillBg} />
      <path
        d="M5 5L11 11M5 11L11 5"
        stroke={fill}
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
